<template>
  <div class="edit-video-tool">
    <div class="edit-video-tool__video-player" @click="onClickVideoPlayer">
      <video id="plyrEdit" preload="metadata" playsinline controls></video>
    </div>
    <div class="edit-video-tool__controls">
      <div class="edit-video-tool__controls__time">
        <div class="edit-video-tool__controls__time__start">
          <MediaPlayerTimeEdit
            type="start"
            :time="getSecondsToTime(startTime, true, 'start')"
            @click-seconds="onClickSeconds"
          />
        </div>
        <div class="edit-video-tool__controls__time__duration">
          Duración clip:
          <span class="edit-video-tool__controls__time__duration__minutes">{{ stringClipDuration }} min.</span>
        </div>
        <div class="edit-video-tool__controls__end">
          <MediaPlayerTimeEdit
            type="end"
            :time="getSecondsToTime(endTime, true, 'end')"
            @click-seconds="onClickSeconds"
          />
        </div>
      </div>
      <div class="edit-video-tool__controls__slider">
        <div class="edit-video-tool__controls__slider__play">
          <img
            v-if="booleanIsPlaying"
            src="https://golstatsimages.blob.core.windows.net/todoelfut/play-pause_02_todoelfut.png"
            alt=""
            @click="onClickPause"
          />
          <img v-else src="https://golstatsimages.blob.core.windows.net/todoelfut/play-pause_02.svg" alt="" @click="onClickPlay" />
        </div>
        <div id="sliderSelector" ref="sliderSelector" class="edit-video-tool__controls__slider__selector">
          <div id="sliderLine" class="line" />
          <BSlider
            v-model="arrayClipLimits"
            :min="numberClipStartLimit"
            :max="numberClipEndLimit"
            rounded
            :step="1"
            :custom-formatter="getTimeFormat"
            :key="`k${sliderKey}`"
            @dragend="onDragEnd"
          />
        </div>
      </div>

      <div role="button" class="edit-video-tool__controls__speed" @click="onClickOpenSpeedModal">
        <div>{{ numberPlayerSpeed }}x</div>
      </div>
    </div>

    <!--  actions  -->
    <div class="edit-video-tool__actions">
      <div role="button" class="edit-video-tool__actions__button" @click="onClickCancel">
        Cancelar
      </div>
      <div role="button" class="edit-video-tool__actions__button save is-green" @click="onClickSaveEdit">
        Guardar edición
      </div>
    </div>

    <MediaPlayerSpeedModal
      :is-modal-open="booleanIsSpeedModalVisible"
      :current-speed="numberPlayerSpeed"
      @close="onModalSpeedClose"
      @click-speed="onClickSpeed"
    />
  </div>
</template>

<script>
import { getPlayContentFields } from '@/data/media-player-play-indexes';

const playContentIndex = getPlayContentFields();
export default {
  name: 'EditVideoTool',
  components: {
    BSlider: async () => {
      const { BSlider } = await import('buefy/dist/esm/slider');
      return BSlider;
    },
    MediaPlayerTimeEdit: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerTimeEdit'),
    MediaPlayerSpeedModal: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSpeedModal'),
  },
  props: {
    videoToEdit: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      videoPlayer: null,
      videoToEditObject: null,
      baseUrl: 'https://golstatsbets.blob.core.windows.net/video-player/',
      seconds: [
        {
          number: 10,
          operation: '-',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_back.svg',
        },
        {
          number: 5,
          operation: '-',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_back.svg',
        },
        {
          number: 1,
          operation: '-',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_back.svg',
        },
        {
          number: 1,
          operation: '+',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_next.svg',
        },
        {
          number: 5,
          operation: '+',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_next.svg',
        },
        {
          number: 10,
          operation: '+',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_next.svg',
        },
      ],
      startLimit: 0,
      startLimitAux: 0,
      startLimitDisplay: 0,
      endLimit: 0,
      endLimitAux: 0,
      endLimitDisplay: 0,
      isVideoDurationEdited: false,
      editType: '',
      matchLapseAbbreviations: {
        '1': '1T',
        '2': '2T',
        '3': '1TE',
        '4': '2TE',
      },
      currentTimeAux: 0,
      wasSetUpLimitsCalled: false,
      syncTimeSeconds: 0,
      secondsToSubtract: 0,
      skipEndLimitCondition: false,
      endPointLimitError: 'El punto de inicio no puede ser igual o mayor al punto final.',
      startPointLimitError: 'El punto final no puede ser igual o menor al punto de inicio.',
      durationLimitError: 'El vídeo editado no puede durar más de 2 minutos.',
      stringStartTime: '00:00',
      stringEndTime: '00:00',
      arrayClipLimits: [0, 0],
      arrayLastClipLimits: [0, 0],
      numberClipStartLimit: 0,
      numberClipEndLimit: 0,
      numberClipRangeStart: 0,
      numberClipRangeEnd: 0,
      numberPixelsPerSecond: 0,
      elementSliderLine: null,
      numberPlayerSpeed: 1,
      booleanIsSpeedModalVisible: false,
      sliderKey: 0,
      resizeObserver: null,
      numberCurrentSeconds: 0,
      booleanIsPlaying: false,
      booleanIsClickOnVideoPlayer: false,
    };
  },
  computed: {
    stringClipDuration() {
      return this.videoToEditObject ? this.getSecondsToTime(this.endLimit - this.startLimit, true) : '00:00';
    },
    matchLapse() {
      return this.videoToEditObject ? this.matchLapseAbbreviations[`${this.videoToEditObject.matchLapse}`] : '';
    },
    startTime() {
      if (this.wasSetUpLimitsCalled && !Number.isNaN(this.startLimit)) {
        return this.startLimitDisplay + this.secondsToSubtract - this.syncTimeSeconds;
      }
      return 0;
    },
    endTime() {
      if (this.endLimit) {
        return this.endLimitDisplay + this.secondsToSubtract - this.syncTimeSeconds;
      }
      return 0;
    },
    gridTemplateColumns() {
      let style = {
        'grid-template-columns': '1fr 0px 1fr',
      };
      if (this.videoPlayer && this.startLimit && this.endLimit) {
        const startPercentage = this.getPercentage(this.startLimit, this.videoPlayer.duration);
        const endPercentage = this.getPercentage(this.videoPlayer.duration - this.endLimit, this.videoPlayer.duration);
        const selectedPercentage = this.getPercentage(this.endLimit - this.startLimit, this.videoPlayer.duration);
        style['grid-template-columns'] = `${startPercentage}% ${selectedPercentage}% ${endPercentage}%`;
      }
      return style;
    },
    backButtonText() {
      return this.editType === 'start' ? 'Fijar punto \nde inicio' : 'Modificar \npunto de inicio';
    },
    nextButtonText() {
      return this.editType === 'end' ? 'Fijar punto \nfinal' : 'Modificar \npunto final';
    },
    isResetVisible() {
      return !this.editType && this.wasSetUpLimitsCalled && this.isVideoDurationEdited;
    },
  },
  watch: {
    videoToEdit(newValue) {
      if (newValue && newValue.length) {
        this.setVideo();
      }
    },
    startLimit(newValue) {
      if (this.videoPlayer) {
        this.videoPlayer.currentTime = newValue;
        if (this.elementSliderLine) {
          this.elementSliderLine.style.left = `${(this.startLimit - this.numberClipRangeStart) *
            this.numberPixelsPerSecond}px`;
        }
      }
    },
  },
  methods: {
    getPercentage(a, b) {
      return ((a / b) * 100).toFixed(2);
    },
    setVideo() {
      if (this.videoToEdit && this.videoToEdit.length) {
        this.videoToEditObject = this.videoToEdit.reduce((accumulator, value, index) => {
          accumulator[playContentIndex[index]] = value;
          return accumulator;
        }, {});
        this.videoToEditObject.startSeconds = this.getPlayTime(this.videoToEditObject, 'startTime');
        this.videoToEditObject.endSeconds = this.getPlayTime(this.videoToEditObject, 'endTime');
        if (this.videoPlayer) {
          this.videoPlayer.source = this.getSrcObject(this.videoToEditObject);
        }
      }
    },
    getPlayTime(gamePlay, timeProp) {
      let syncTime = '';
      let minutesToSubtract = 0;
      switch (gamePlay.matchLapse) {
        case 1:
          syncTime = gamePlay.syncStartFirstTime;
          break;
        case 2:
          syncTime = gamePlay.syncStartSecondTime;
          minutesToSubtract = 45;
          break;
        case 3:
          syncTime = gamePlay.syncStartFirstExtraTime;
          minutesToSubtract = 90;
          break;
        case 4:
          syncTime = gamePlay.syncStartSecondExtraTime;
          minutesToSubtract = 105;
          break;
        case 5:
          syncTime = gamePlay.syncStartPenals;
          minutesToSubtract = 120;
          break;
      }
      if (!syncTime || syncTime === '0') {
        syncTime = '00:00';
      }
      this.syncTimeSeconds = this.getTimeToSeconds(syncTime);
      this.secondsToSubtract = minutesToSubtract * 60;
      return this.syncTimeSeconds + (this.getTimeToSeconds(gamePlay[timeProp]) - this.secondsToSubtract);
    },
    getTimeToSeconds(timeString) {
      const dotIndex = timeString.indexOf('.');
      const stringAux = dotIndex > -1 ? timeString.substring(0, timeString.indexOf('.')) : timeString;
      const [seconds, minutes, hours] = stringAux.split(':').reverse();

      return (hours ? Number(hours) * 60 * 60 : 0) + Number(minutes) * 60 + Number(seconds);
    },
    getSecondsToTime(seconds, isSimple = false, type = 'start') {
      let isNegative = seconds < 0;
      // eslint-disable-next-line no-param-reassign
      seconds = Math.abs(seconds);
      if (!isNegative) {
        isNegative = this[`${type}LimitDisplay`] < this.syncTimeSeconds;
      }
      const minutes = Math.floor(seconds / 60);
      const secondsRemaining = Math.floor(seconds - minutes * 60);
      const minutesPrefix = minutes < 10 ? '00' : minutes < 100 ? '0' : '';
      const secondsPrefix = secondsRemaining < 10 ? '0' : '';
      return `${isNegative ? '-' : ''}${isSimple ? '' : minutesPrefix}${minutes}:${secondsPrefix}${secondsRemaining}${
        isSimple ? '' : '.000'
      }`;
    },
    getSrcObject(gamePlay) {
      return {
        type: 'video',
        sources: [
          {
            src: `${this.baseUrl}${gamePlay.gameId}_1.mp4`,
            type: 'video/mp4',
            size: 720,
          },
        ],
      };
    },
    plyrInit() {
      const videoPlayerElement = document.getElementById('plyrEdit');
      this.setVideo();
      if (videoPlayerElement) {
        this.videoPlayer = new window.Plyr(videoPlayerElement, this.getPlyrOptions());
        this.videoPlayer.on('loadeddata', this.getOnLoadedData());
        this.videoPlayer.on('timeupdate', this.getOnTimeUpdate());
        this.videoPlayer.on('play', this.getOnPlay());
        this.videoPlayer.on('pause', this.getOnPause());
        // this.videoPlayer.on('playing', this.getOnPlaying());
        this.setVideo();
      }
    },
    getPlyrOptions() {
      return {
        autoplay: false,
        speed: { selected: 1, options: [1, 2, 3] },
        invertTime: false,
        muted: false,
        seekTime: 5,
        controls: [
          // 'fullscreen', // Toggle fullscreen
          // 'progress', // The progress bar and scrubber for playback and buffering

          'play', // Play/pause playback
          'current-time', // The current time of playback
          'duration', // The full duration
          'volume', // The volume
          'play-large', // The large play button in the center
        ],
        // ratio: '47:20',
      };
    },
    getOnTimeUpdate() {
      const vm = this;
      return () => {
        this.numberCurrentSeconds = this.videoPlayer.currentTime;
        if (vm.videoPlayer.currentTime <= vm.endLimit) {
          vm.elementSliderLine.style.left = `${(vm.videoPlayer.currentTime - vm.numberClipRangeStart) *
          vm.numberPixelsPerSecond}px`;
        }
        if (!vm.booleanIsClickOnVideoPlayer && vm.videoPlayer.currentTime >= vm.endLimit) {
          vm.videoPlayer.pause();
          vm.videoPlayer.currentTime = vm.startLimit;
          vm.elementSliderLine.style.left = `${(vm.startLimit - vm.numberClipRangeStart) * vm.numberPixelsPerSecond}px`;
        }
        // if (vm.editType) {
        //   vm[`${vm.editType}LimitDisplay`] = vm.videoPlayer.currentTime;
        //   if (!vm.skipEndLimitCondition && vm.videoPlayer && vm.videoPlayer.currentTime >= vm.endLimit) {
        //     vm.videoPlayer.pause();
        //     if (vm.editType === 'start') {
        //       vm.videoPlayer.currentTime = vm.startLimit;
        //     }
        //   }
        // }
      };
    },
    getOnPlay() {
      const vm = this;
      return () => {
        vm.booleanIsPlaying = true;
        if (vm.editType) {
          vm.skipEndLimitCondition = false;
          if (vm.videoPlayer.currentTime >= vm.endLimit) {
            vm.videoPlayer.currentTime = vm.startLimit;
          }
        }
      };
    },
    getOnPause() {
      const vm = this;
      return () => {
        vm.booleanIsPlaying = false;
      };
    },
    onClickVideoPlayer() {
      this.booleanIsClickOnVideoPlayer = true;
    },
    onClickPause() {
      this.videoPlayer.pause();
    },
    getTimeFormat(value) {
      return this.getSecondsToTime(value, true, 'start');
    },
    setUpLimits() {
      if (this.videoToEditObject) {
        const startLimit = this.videoToEditObject.startSeconds;
        const endLimit = this.videoToEditObject.endSeconds;
        this.numberClipRangeStart = startLimit - 120 < 0 ? 0 : startLimit - 120;
        this.numberClipRangeEnd = endLimit;
        this.startLimit = startLimit;
        this.startLimitAux = this.startLimit;
        this.startLimitDisplay = this.startLimit;
        this.endLimit = endLimit;
        this.endLimitAux = this.endLimit;
        this.endLimitDisplay = this.endLimit;
        this.wasSetUpLimitsCalled = true;
        const elementSliderSelector = document.getElementById('sliderSelector');
        this.elementSliderLine = document.getElementById('sliderLine');
        setTimeout(() => {
          this.numberClipStartLimit = this.startTime - 120 < 0 ? 0 : this.startTime - 120;
          this.numberClipEndLimit =
            this.endTime + 120 > this.videoPlayer.duration ? this.videoPlayer.duration : this.endTime + 120;
          this.arrayClipLimits = [this.startTime, this.endTime];
          this.arrayLastClipLimits = [this.startTime, this.endTime];
          const numberElementWidth = elementSliderSelector.getBoundingClientRect().width;
          this.numberPixelsPerSecond = numberElementWidth / (this.numberClipEndLimit - this.numberClipStartLimit);
          this.elementSliderLine.style.left = `${(this.startLimit - this.numberClipRangeStart) *
            this.numberPixelsPerSecond}px`;
        }, 1000);
      }
    },
    getOnLoadedData() {
      const vm = this;
      return () => {
        vm.videoPlayer.currentTime = vm.videoToEditObject.startSeconds;
        vm.currentTimeAux = vm.videoPlayer.currentTime;
        if (vm.videoPlayer.duration) {
          vm.setUpLimits();
        }
      };
    },
    onClickOpenSpeedModal() {
      this.booleanIsSpeedModalVisible = true;
    },
    onModalSpeedClose() {
      this.booleanIsSpeedModalVisible = false;
    },
    onClickSpeed(numberSpeed) {
      this.numberPlayerSpeed = numberSpeed;
      this.videoPlayer.speed = numberSpeed;
      this.booleanIsSpeedModalVisible = false;
    },
    onClickResetLimits() {
      this.isVideoDurationEdited = false;
      this.startLimit = this.videoToEditObject.startSeconds;
      this.startLimitDisplay = this.startLimit;
      this.endLimit = this.videoToEditObject.endSeconds;
      this.endLimitDisplay = this.endLimit;
      this.videoPlayer.pause();
      this.videoPlayer.currentTime = this.startLimit;
    },
    onClickPlay() {
      this.booleanIsClickOnVideoPlayer = true;
      this.videoPlayer.currentTime = this.startLimit;
      this.videoPlayer.play();
    },
    onClickSetTime(stringType, numberSecondsToAdd) {
      this.isVideoDurationEdited = true;
      this[`${stringType}Limit`] = this[`${stringType}Limit`] + numberSecondsToAdd;
      this[`${stringType}LimitAux`] = this[`${stringType}Limit`];
      this[`${stringType}LimitDisplay`] = this[`${stringType}Limit`];
      this.videoPlayer.currentTime = this[`${stringType}Limit`];
      this.videoPlayer.pause();
      if (stringType === 'start') {
        this.arrayClipLimits[0] = this.startTime;
        this.arrayLastClipLimits[0] = this.startTime;
      } else {
        this.arrayClipLimits[1] = this.endTime;
        this.arrayLastClipLimits[1] = this.endTime;
      }
      this.sliderKey += 1;
      // if (this.editType === type) {
      //   this.isVideoDurationEdited = true;
      //   this[`${type}Limit`] = this.videoPlayer.currentTime;
      //   this[`${type}LimitAux`] = this[`${type}Limit`];
      //   this[`${type}LimitDisplay`] = this[`${type}Limit`];
      //   this.videoPlayer.currentTime = this.startLimit;
      // } else {
      //   let errorMsg = '';
      //   if (type === 'start') {
      //     if (this.videoPlayer.currentTime >= this.endLimit) {
      //       errorMsg = this.endPointLimitError;
      //     }
      //   } else {
      //     if (this.videoPlayer.currentTime <= this.startLimit) {
      //       errorMsg = this.startPointLimitError;
      //     }
      //   }
      //   if (errorMsg) {
      //     this.showError(errorMsg);
      //   } else {
      //     this[`${type}Limit`] = this.videoPlayer.currentTime;
      //     this[`${type}LimitDisplay`] = this[`${type}Limit`];
      //     this.editType = type;
      //   }
      // }
    },
    onClickCancelTime($event, isFromSaveEdit = false) {
      if (!isFromSaveEdit) {
        this[`${this.editType}Limit`] = this[`${this.editType}LimitAux`];
        this[`${this.editType}LimitDisplay`] = this[`${this.editType}Limit`];
      }
      this.editType = '';
    },
    onClickSeconds({ stringType, numberSeconds }) {
      this.skipEndLimitCondition = true;
      const videoMaxSecondsDuration = 120;
      let errorMsg = '';
      let secondsToAdd = numberSeconds;
      this.videoPlayer.pause();
      const numberStartSeconds = this.arrayClipLimits[0];
      const numberEndSeconds = this.arrayClipLimits[1];
      if (stringType === 'start') {
        if (numberStartSeconds + secondsToAdd < this.numberClipStartLimit) {
          secondsToAdd = this.numberClipStartLimit;
        } else if (numberStartSeconds + secondsToAdd >= numberEndSeconds) {
          errorMsg = this.endPointLimitError;
        } else if (numberEndSeconds - numberStartSeconds + secondsToAdd > videoMaxSecondsDuration) {
          errorMsg = this.durationLimitError;
        }
      } else {
        if (numberEndSeconds + secondsToAdd > this.numberClipEndLimit) {
          secondsToAdd = this.numberClipEndLimit;
        } else if (numberEndSeconds + secondsToAdd <= numberStartSeconds) {
          errorMsg = this.startPointLimitError;
        } else if (numberEndSeconds - numberStartSeconds + secondsToAdd > videoMaxSecondsDuration) {
          errorMsg = this.durationLimitError;
        }
      }
      if (errorMsg) {
        this.showError(errorMsg);
      } else {
        this.onClickSetTime(stringType, secondsToAdd);
      }
    },
    showError(msg) {
      this.$buefy.notification.open({
        duration: 6000,
        message: msg,
        type: 'is-danger',
      });
    },
    setUpResizeObserver() {
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          const numberElementWidth = this.$refs.sliderSelector.getBoundingClientRect().width;
          this.numberPixelsPerSecond = numberElementWidth / (this.numberClipEndLimit - this.numberClipStartLimit);
          this.elementSliderLine.style.left = `${this.numberCurrentSeconds * this.numberPixelsPerSecond}px`;
        });

        this.resizeObserver.observe(this.$refs.sliderSelector);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    onDragEnd() {
      if (this.arrayClipLimits[1] - this.arrayClipLimits[0] > 120) {
        this.arrayClipLimits[0] = this.arrayLastClipLimits[0];
        this.arrayClipLimits[1] = this.arrayLastClipLimits[1];
        this.sliderKey += 1;
        this.showError(this.durationLimitError);
      }
      if (this.arrayClipLimits[0] !== this.arrayLastClipLimits[0]) {
        this.onClickSetTime('start', this.arrayClipLimits[0] - this.arrayLastClipLimits[0]);
      }
      if (this.arrayClipLimits[1] !== this.arrayLastClipLimits[1]) {
        this.onClickSetTime('end', this.arrayClipLimits[1] - this.arrayLastClipLimits[1]);
      }
    },
    onClickCancel() {
      this.$emit('cancel');
    },
    onClickSaveNoEdit() {
      this.$emit('save', null);
    },
    onClickSaveEdit() {
      const startDiff = this.startLimit - this.videoToEditObject.startSeconds;
      const endDiff = this.endLimit - this.videoToEditObject.endSeconds;
      const startTime = this.getSecondsToTime(this.getTimeToSeconds(this.videoToEditObject.startTime) + startDiff);
      const endTime = this.getSecondsToTime(this.getTimeToSeconds(this.videoToEditObject.endTime) + endDiff);
      this.onClickSpeed(1);
      this.$emit('save', { startTime, endTime });
    },
  },
  mounted() {
    this.elementSliderLine = document.getElementById('sliderLine');
    this.setUpResizeObserver();
    this.plyrInit();
  },
};
</script>

<style scoped lang="scss">
#videoHidden {
  display: none;
  visibility: hidden;
}

.edit-video-tool {
  width: 100%;

  &__video-player {
    width: 100%;
  }

  &__controls {
    margin-top: 5px;
    width: 100%;
    border-radius: 10px;
    border: dotted 1px #d0d6df;
    padding: 12px;

    &__time {
      display: grid;
      grid-template-columns: min-content 1fr min-content;
      grid-template-areas: 'start-edit clip-duration end-edit';
      grid-gap: 10px;

      &__start {
        width: 100%;
        grid-area: start-edit;
      }

      &__end {
        width: 100%;
        grid-area: end-edit;
      }

      &__duration {
        width: 100%;
        grid-area: clip-duration;
        align-self: center;
        white-space: nowrap;
      }

      @media screen and (max-width: 560px) {
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: 'start-edit end-edit' 'clip-duration clip-duration';
      }
    }

    &__slider {
      width: 100%;
      padding: 12px 8px 10px;
      margin-top: 8px;
      display: grid;
      grid-template-columns: min-content 1fr;
      border-radius: 5px;
      border: solid 1px #000;

      &__play {
        margin-top: 5px;
        height: 32px;
        width: 32px;
        cursor: pointer;

        & > img {
          height: 100%;
          width: 100%;
        }
      }

      &__selector {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;

        & > div.line {
          height: 50px;
          left: 20px;
          border-left: 2px solid red;
          position: absolute;
        }
      }
    }

    &__speed {
      margin-top: 8px;
      display: flex;
      justify-content: center;
      cursor: pointer;

      & > div {
        width: 74px;
        padding: 0.4em 0 0.4em;
        border-radius: 16px;
        background-color: #cbee6b;
        font-family: Roboto-Bold, sans-serif;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.83;
        letter-spacing: -0.14px;
        text-align: center;
        color: #132839;
      }
    }
  }

  &__actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 3%;
    margin: 12px 0;

    &__button {
      padding: 16px 0 14px;
      border-radius: 25px;
      border: solid 1px #132839;
      font-family: Avenir-Demi, sans-serif;
      font-size: 19px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.84;
      letter-spacing: -0.38px;
      color: #132839;
      cursor: pointer;

      &.save {
        background-color: #f0f0f0;
        border: solid 1px #f0f0f0;
        color: #8e919c;
      }

      &.is-green {
        border: solid 1px #cbee6b;
        background-color: #cbee6b;
        color: #132839;
      }
    }
  }
}

.time-setter {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 4px;
  font-family: Avenir-Medium, sans-serif;

  &__button {
    padding: 10px;
    border-radius: 6px;
    background-color: #132839;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.07;
    letter-spacing: -0.3px;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
  }

  &__current {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: #f0f0f0;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.07;
    letter-spacing: -0.3px;
    color: #132839;
  }
}

.separator {
  width: 100%;
  margin: 12px 0;
  border-bottom: dotted 1px #878e93;

  &.is-mobile {
    display: none;
  }
}
</style>

<style lang="scss">
.edit-video-tool {
  & .b-slider.is-primary .b-slider-fill {
    background: #00a5ff !important;
  }

  & .b-tooltip.is-top.is-primary:before {
    border-top: 5px solid #00a5ff;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    bottom: calc(100% + 2px);
  }

  & .b-tooltip.is-primary:after {
    background: #00a5ff;
    color: #fff;
  }
}
</style>
